export const isWebApp: boolean = true;
